module.exports = __webpack_public_path__ + "static/media/hardy-sets-demo1.fbde2151.png";